import { BoundingBoxAnchor } from '@kibsi/ks-application-types'

export type AnchorPosition = BoundingBoxAnchor['position']
